export default __webpack_public_path__ + "static/media/fire-home-package.37e4f852.png";